<template>
  <div v-if="priceDrop">
    <span class="body-2-bold text-static-success-hi">
      {{
        i18n(translations.sellerFlashSalesDiscount, {
          price: i18n.price(priceDrop),
        })
      }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Price } from '@backmarket/core-types/Price'
import type { PriceNumber } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { calculateReduction } from '@backmarket/utils/math/calculateReduction'

import { normalizePrice } from '../../helpers/normalizePrice/normalizePrice'

import translations from './SellerFlashSalesSavings.translations'

const i18n = useI18n()

const props = defineProps<{
  price: Price
  lastLowestPrice: Price | PriceNumber
}>()

const priceDrop = computed(() => {
  const reduction = calculateReduction(
    normalizePrice(props.lastLowestPrice),
    props.price,
  )

  if (!reduction || parseFloat(reduction.amount) <= 0) {
    return null
  }

  return reduction
})
</script>
